import { IEstimateTemplateData } from "common/records/EstimateTemplate";
import { createAction } from "common/reducers/Utils";
import { ActionsUnion } from "common/reducers/UtilsTypes";
import { List } from "immutable";

export const FETCH_ESTIMATE_TEMPLATE = "@estimateTemplates/FETCH_ESTIMATE_TEMPLATE";
export const RECEIVE_ESTIMATE_TEMPLATE = "@estimateTemplates/RECEIVE_ESTIMATE_TEMPLATE";
export const RECEIVE_ESTIMATE_TEMPLATES = "@estimateTemplates/RECEIVE_ESTIMATE_TEMPLATES";
export const EDIT_ESTIMATE_TEMPLATE = "@estimateTemplates/EDIT_ESTIMATE_TEMPLATE";
export const EDIT_ESTIMATE_TEMPLATES = "@estimateTemplates/EDIT_ESTIMATE_TEMPLATES";
export const REMOVE_ESTIMATE_TEMPLATE = "@estimateTemplates/REMOVE_ESTIMATE_TEMPLATE";
export const SET_ESTIMATE_TEMPLATE_LOADED = "@estimateTemplates/SET_ESTIMATE_TEMPLATE_LOADED";

export const EstimateTemplateActions = {
  fetchEstimateTemplate: (id: number) => createAction(FETCH_ESTIMATE_TEMPLATE, { id }),
  setEstimateTemplateLoaded: (id: number) => createAction(SET_ESTIMATE_TEMPLATE_LOADED, { id }),
  receiveEstimateTemplate: (estimateTemplate: Partial<IEstimateTemplateData>) =>
    createAction(RECEIVE_ESTIMATE_TEMPLATE, { estimateTemplate }),
  receiveEstimateTemplates: (estimateTemplates: Partial<IEstimateTemplateData>[]) =>
    createAction(RECEIVE_ESTIMATE_TEMPLATES, { estimateTemplates }),
  /** Set a single field on one template (inline rename, folder move) — mirrors DocumentActions.editDocument. */
  editEstimateTemplate: (id: number, name: string, value: unknown) =>
    createAction(EDIT_ESTIMATE_TEMPLATE, { id, name, value }),
  /** Set the same field on many templates (batch folder move) — mirrors DocumentActions.editDocuments. */
  editEstimateTemplates: (ids: List<number>, name: string, value: unknown) =>
    createAction(EDIT_ESTIMATE_TEMPLATES, { ids, name, value }),
  removeEstimateTemplate: (id: number) => createAction(REMOVE_ESTIMATE_TEMPLATE, { id }),
};

export type EstimateTemplateActions = ActionsUnion<typeof EstimateTemplateActions>;
